import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/sharp-light-svg-icons";

interface FilterButtonProps {
  onClick?: () => void;
  label: string;
  disabled?: boolean;
  loading: boolean;
  selected: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  label,
  selected,
  loading,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      type="submit"
      disabled={disabled || loading}
      className={
        selected
          ? "text-[var(--filter-button-active-text-color)] relative homepage-text-sm  bg-[var(--filter-button-active-bg-color)] border-[var(--filter-button-active-border-color)] filter-button py-2 px-2 lg:px-3 flex gap-2"
          : "text-[var(--filter-button-text-color)] border hover:text-[var(--filter-button-active-text-color)] hover:bg-[var(--filter-button-active-bg-color)] hover:border-[var(--filter-button-active-border-color)] relative homepage-text-sm  bg-[var(--filter-button-bg-color)] border-[var(--filter-button-border-color)] filter-button py-2 px-2 lg:px-3 flex gap-2"
      }
    >
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center opacity-30">
          <FontAwesomeIcon
            className="size-6 text-[var(--filter-button-text-color)] animate-spin"
            icon={faSpinnerThird}
          />
        </div>
      )}
      {label}
    </button>
  );
};

export default FilterButton;
